import axios from 'axios';
import { Authentication } from '@icabbi/vue-authentication';

const defaultState = {
  onboardingApiServiceClient: null,
  configGenerationInProgress: false,
  generatedConfig: undefined,
};

const getters = {
  generatedConfig: state => state.generatedConfig,
  configGenerationInProgress: state => state.configGenerationInProgress,
  onboardingApiServiceClient: (state, contextGetters, rootState, rootGetters) => ({ dispatch }) => {
    const authentication = Authentication({ dispatch, getters: rootGetters });
    const { authenticationFailureInterceptor, bearerTokenInterceptor } = authentication;
    if (state.onboardingApiServiceClient === null) {
      state.onboardingApiServiceClient = axios.create({
        baseURL: process.env.VUE_APP_ONBOARDING_SERVICE_BASE_URL,
        timeout: 30000,
      });
      state.onboardingApiServiceClient.interceptors.response.use(
        undefined, error => authenticationFailureInterceptor(error),
      );
      state.onboardingApiServiceClient.interceptors.request.use(
        config => bearerTokenInterceptor(config),
      );
    }
    return state.onboardingApiServiceClient;
  },
};

const actions = {
  async generateConfig(context, { bookingChannelId, fleetId, enablePassengerPay }) {
    try {
      context.commit('setConfigGenerationInProgress', true);
      const result = await context.getters.onboardingApiServiceClient(context)
        .get('/trackmytaxi/config', {
          params: {
            bookingChannelId, fleetId, enablePassengerPay,
          },
        });
      context.commit('setGeneratedConfig', result.data);
    } catch (error) {
      context.dispatch(
        'globalMessages/addError',
        { message: 'trackmytaxi.config.generationError', error },
        { root: true },
      );
    } finally {
      context.commit('setConfigGenerationInProgress', false);
    }
  },
};

const mutations = {
  setConfigGenerationInProgress(state, configGenerationInProgress) {
    state.configGenerationInProgress = configGenerationInProgress;
  },
  setGeneratedConfig(state, config) {
    state.generatedConfig = config;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
